import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=22822b54&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
import style0 from "./Select.vue?vue&type=style&index=0&id=22822b54&prod&lang=scss&scoped=true"
import style1 from "./Select.vue?vue&type=style&index=1&id=22822b54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22822b54",
  null
  
)

export default component.exports